export default {
    WorkflowDesign: {
        name: '流程名称',
        Add: '新增流程',
        View: '查看',
        Deployment: '布署',
        Process: '流程定义ID',
        ID: '部署ID',
        file: '流程文件名称',
        Status: '状态',
        Version: '版本',
        Operation: '操作',
        want: '操作中，是否继续?',
        form: {
            Empty: '清空',
            Import: '导入文件',
            Export: '导出文件',
            pictures: '导出图片',
            Save: '保存为新版本',
            version: '您正在 将此流程作为新版本保存，新版本需要再次布署才会生效（未重新布署期间依旧会执行旧版本流程），是否继续?',
            please: '打开模型出错,请确认该模型符合Bpmn2.0规范',
            ps: '保存成功',
            cancel: '当前页面数据未保存，是否放弃？',
            cancel1: '已取消',
        }
    }
};
